import { useQuery } from "@tanstack/react-query";
import {
  GetLifecycleManagementDrawerOrdersResponse,
  GetLifecycleManagementDrawerOrdersSearchRequest,
  LifecycleManagementClient,
} from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../../../../auth/ApiClientConfig";
import { ASSET_LIFECYCLE_QUERY_KEYS } from "../constants";

export function useGetAssetLifecycleManagementDrawerOrdersData(
  request: GetLifecycleManagementDrawerOrdersSearchRequest,
) {
  function fetchAssetLifecycleData(): Promise<GetLifecycleManagementDrawerOrdersResponse> {
    const api = new LifecycleManagementClient(
      ApiClientConfig,
      import.meta.env.API_ENDPOINT,
    );
    return api.getDrawerOrdersDetails(request);
  }

  return useQuery({
    queryKey: [ASSET_LIFECYCLE_QUERY_KEYS.drawerOrders, request],
    queryFn: async () => {
      return await fetchAssetLifecycleData();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
